import axios from 'axios'

export const listAdmins = () => {
    return axios.get('/ajax/admins/list')
}
export const sendPassowrdReset = email => {
    return axios.post('/ajax/password/email', { email })
}
export const resetPassword = data => {
    return axios.post('/ajax/password/reset', data)
}
export const login = loginInfo => {
    return axios.post('/ajax/login', loginInfo)
}
export const timeToRefresh = () => {
    return axios.get('/ajax/time-to-refresh')
}
export const logout = () => {
    return axios.get('/ajax/logout')
}
export const listUsers = companyId => {
    return axios.get('/ajax/users/list?id=' + companyId)
}
export const deleteUser = info => {
    return axios.post('/ajax/users/delete', info)
}
export const me = () => {
    return axios.get('/ajax/me')
}
export const dashboard = data => {
    return axios.post('/ajax/dashboard', data)
}
export const userFeatureFlags = data => {
    return axios.post('/ajax/user-feature-flags', data)
}
